import { GetManyResponse, BaseRecord } from '@refinedev/core';

export const filterConfirmationData = (
  data: GetManyResponse<BaseRecord> | undefined,
  projectItemId: string
) => {
  return data?.data.filter((item) => item.project.includes(projectItemId));
};
